import { useEffect } from "react";
import axios from "axios";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Utilities from "@/components/site/Utilities";
import WhyUs from "@/components/site/WhyUs";
import RequestForm from "@/components/site/RequestForm";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import MobileCTAPopup from "@/components/site/MobileCTAPopup";
import FloatingCallButton from "@/components/site/FloatingCallButton";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HomePage() {
  useEffect(() => {
    axios.get(`${API}/`).catch(() => {});
    // Remove platform-injected badge so our floating CTA / mobile popup
    // sits cleanly in the bottom-right area without overlap.
    const removeBadge = () => {
      const el = document.getElementById("emergent-badge");
      if (el) el.remove();
    };
    removeBadge();
    const interval = setInterval(removeBadge, 500);
    const timeout = setTimeout(() => clearInterval(interval), 8000);
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div className="bg-white text-zinc-900 min-h-screen">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Utilities />
        <WhyUs />
        <RequestForm />
        <Contact />
      </main>
      <Footer />
      <MobileCTAPopup />
      <FloatingCallButton />
    </div>
  );
}
